export default __webpack_public_path__ + "navigation-examples-custom-destination-marker-v1-1200-ff79e6b8b12d50c1abbf4c36a931801f.png";